import actions from "./actions";

const initState = {
  reservationHistory: [],
  loading: false,
};

export default function reservationHistoryReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.GET_RESERVATIONS_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case actions.UPDATE_RESERVATION_TOUCHSALE_SUM_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case actions.GET_RESERVATIONS_HISTORY_SUCCESS:
      return {
        ...state,
        reservationHistory: action.reservationHistory,
        loading: false,
      };

    case actions.GET_RESERVATIONS_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case actions.UPDATE_RESERVATION_TOUCHSALE_SUM_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case actions.UPDATE_RESERVATION_TOUCHSALE_SUM_FAILURE:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
